import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsEnum, IsNumber, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';
import { EAcquirerService } from '../billing/task.enums';

@Index('billing_subscription__entity_name_id', ['entityName', 'entityId'], {
  unique: true,
  where: `"deletedAt" IS NULL`,
})
export class Subscription extends BasicEntity {
  @Column({ type: 'int', nullable: true })
  parentId?: number;

  @Column({ type: 'int', nullable: false })
  accountId: number;

  @ApiProperty()
  @Column({ type: 'varchar', nullable: false })
  @IsString()
  entityName: string;

  @ApiProperty()
  @Column({ type: 'int', nullable: false })
  @IsNumber()
  entityId: number;

  @ApiProperty()
  @IsNumber()
  @Column({
    type: 'timestamptz',
    precision: 3,
    nullable: false,
  })
  until: Date; // end date of the current subscription period

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  currentPlan: number;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: true })
  nextPlan?: number | null; // plan to switch to when the subscription ends; null keeps the current plan,
  // 0 means subscription cancellation

  @ApiProperty()
  @IsNumber()
  @Column({
    type: 'timestamptz',
    precision: 3,
    nullable: true,
  })
  nextPlanPaidUntil?: Date | null; // end date of the nextPlan subscription period; relevant only with nextPlan

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  prolongFailedCount: number; // failed renewal attempt counter

  @IsEnum(EAcquirerService)
  @Column({
    type: 'int',
    enum: EAcquirerService,
    nullable: false,
    default: EAcquirerService.unknown,
  })
  acquirer: EAcquirerService; // payment provider used for the subscription

  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  acquirerSubscriptionId: string; // subscription ID in the payment provider (RebillId for T-Kassa)
}
